import React, { Component } from 'react'
import PropTypes from 'prop-types'

import axios from 'axios'

import { Container, Row, Col, Image, Form, Button, Modal } from 'react-bootstrap'

import { IMaskInput } from "react-imask"

import styles from './../blocks.module.sass'

export default class Main extends Component {

  constructor(props) {
    super(props)

    this.state = {
      remember: true,
      form: 'login',
      email: '',
      phone: '',
      dob: '',
      pass: '',
      show: false,
      modal_title: '',
      modal_body: ''
    }
  }

  rememberChange = () => {
    this.setState({
      remember: !this.state.remember
    })
  }

  formChange = ( form ) => {
    this.setState({
      form: form
    })
  }

  change_email = ( val ) => {
    this.setState({
      email: val
    })
  }
  change_phone = ( val ) => {
    this.setState({
      phone: val
    })
  }
  change_dob = ( val ) => {
    this.setState({
      dob: val
    })
  }
  change_pass = ( val ) => {
    this.setState({
      pass: val
    })
  }

  submitForm = ( e ) => {
    const { form, email, phone, dob, pass } = this.state
    e.preventDefault()

    const main = this,
    baseURL = window.location.protocol + "//" + window.location.hostname
    axios.post(`${baseURL}`, {
      'content_type': 'application/json',
      'action': 'login_page',
      'form': form,
      'email': email,
      'phone': phone,
      'dob': dob,
      'pass': pass
    }).then( ( response ) => {
      if( form == 'login' ) {
        if( response.data.success ) {
          location.reload()
        } else {
          main.setState({
            show: true,
            modal_title: `Ошибка`,
            modal_body: response.data.massage
          })
        }
      }
      if( form == 'remember' ) {
        if( response.data.success ) {
          main.setState({
            show: true,
            modal_title: `Забыли пароль?`,
            modal_body: `Доступы отправлены на ваш E-mail`
          })
        } else {
          main.setState({
            show: true,
            modal_title: `Ошибка`,
            modal_body: `Пользователь не найден`
          })
        }
      }
      if( form == 'register' ) {
        if( response.data.success ) {
          location.reload()
        } else {
          main.setState({
            show: true,
            modal_title: `Ошибка`,
            modal_body: response.data.massage
          })
        }
      }
    })
  }

  handleClose = () => {
    this.setState({
      show: false
    })
  }

  render() {

    const { ajax_data } = this.props,
    { remember, form, email, phone, dob, pass, show, modal_title, modal_body } = this.state,
    { handleClose } = this

    return (
      <>
        <div className={styles.login_form}>
          <Container>
            <Row>
              <Col className={styles.login_form_lcolumn} lg={6}>
                {form == 'login' &&
                  <div className={styles.login_form_fcontener}>
                    <div className={styles.login_form_title}>Вход в учетную запись</div>
                    <div className={styles.login_form_podpis}>Авторизируйтесь, чтобы попасть в личный кабинет</div>
                    <Form onSubmit={( e ) => this.submitForm( e )}>
                      <Form.Control className={styles.login_form_input} type="email" value={email} onChange={( e ) => this.change_email( e.target.value )} placeholder="Введите почту" />
                      <Form.Control className={styles.login_form_input} type="password" value={pass} onChange={( e ) => this.change_pass( e.target.value )} placeholder="Введите пароль" />
                      <div className='w-100 d-flex align-items-center justify-content-between'>
                        <div onClick={() => this.rememberChange()} style={{ cursor: `pointer` }} className='d-flex align-items-center'>
                          <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <rect x="0.375" y="0.375" width="16.25" height="16.25" rx="8.125" fill="white" stroke="black" strokeWidth="0.75"/>
                            {remember &&
                              <rect x="5" y="5" width="7" height="7" rx="3.5" fill="black"/>
                            }
                          </svg>
                          <div className={styles.login_form_remember}>Запомнить меня</div>
                        </div>
                        <div onClick={() => this.formChange('remember')} className={styles.login_form_zpass}>Забыли пароль?</div>
                      </div>
                      <Button type="submit" className={styles.login_form_btn} variant="dark">Войти</Button>
                    </Form>
                    <div onClick={() => this.formChange('register')} className={styles.login_form_zareg_lnk}>Нет учетной записи? <span>Зарегистрируйтесь</span></div>
                  </div>
                }
                {form == 'remember' &&
                  <div className={styles.login_form_fcontener}>
                    <div className={styles.login_form_title}>Забыли пароль?</div>
                    <div className={styles.login_form_podpis}>Укажите ваш E-mail и мы отправим на него инструкцию для восстановления доступа</div>
                    <Form onSubmit={( e ) => this.submitForm( e )}>
                      <Form.Control className={styles.login_form_input} type="email" value={email} onChange={( e ) => this.change_email( e.target.value )} placeholder="Введите почту" />
                      <div className='w-100 d-flex align-items-center justify-content-between'>
                        <div> </div>
                        <div onClick={() => this.formChange('login')} className={styles.login_form_zpass}>Войти</div>
                      </div>
                      <Button type="submit" className={styles.login_form_btn} variant="dark">Отправить</Button>
                    </Form>
                    <div onClick={() => this.formChange('register')} className={styles.login_form_zareg_lnk}>Нет учетной записи? <span>Зарегистрируйтесь</span></div>
                  </div>
                }
                {form == 'register' &&
                  <div className={styles.login_form_fcontener}>
                    <div className={styles.login_form_title}>Регистрация</div>
                    <div className={styles.login_form_podpis}>Зарегистрируйтесь, чтобы попасть в личный кабинет</div>
                    <Form onSubmit={( e ) => this.submitForm( e )}>
                      <Form.Control className={styles.login_form_input} type="email" value={email} onChange={( e ) => this.change_email( e.target.value )} placeholder="Введите почту" />
                      <Form.Control as={IMaskInput} mask="+{7} (000) 000-00-00" lazy={true} type="phone" className={styles.login_form_input} value={phone} onChange={( e ) => this.change_phone( e.target.value )} placeholder="Введите ваш номер телефона" />
                      <Form.Control as={IMaskInput} mask={Date} lazy={true} className={styles.login_form_input} type="text" value={dob} onChange={( e ) => this.change_dob( e.target.value )} placeholder="Введите дату рождения" />
                      <Form.Control className={styles.login_form_input} type="password" value={pass} onChange={( e ) => this.change_pass( e.target.value )} placeholder="Введите пароль" />
                      <div className='w-100 d-flex align-items-center justify-content-between'>
                        <div> </div>
                        <div onClick={() => this.formChange('login')} className={styles.login_form_zpass}>Войти</div>
                      </div>
                      <Button type="submit" className={styles.login_form_btn} variant="dark">Зарегестрироватся</Button>
                    </Form>
                  </div>
                }
              </Col>
              <Col lg={6}>
                {ajax_data.image &&
                  <Image className={styles.login_form_img} src={ajax_data.image} width="617" height="752" alt="Вход в учетную запись" />
                }
              </Col>
            </Row>
          </Container>
        </div>
        <Modal centered show={show} onHide={handleClose}>
          <Modal.Header closeButton>
            <Modal.Title>{modal_title}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className='text-center'>{modal_body}</div>
          </Modal.Body>
        </Modal>
      </>
    )
  }
}

Main.propTypes = {
  ajax_data: PropTypes.object
}